/*--------------------------------------------------------------------------------------------
Program     :  HolidayDialog.js
Description :  Main program for Map and Track  to view HolidayDialog
Date        :  03/07/2025 
Created By  :  Jelbin
---------------------------------------------------------------------------------------------
TicketNo        Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
03072025       -Jelbin     -  03/07/2025         Created
---------------------------------------------------------------------------------------------*/
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Stack, Tooltip, Typography, TextField, Box } from '@mui/material';

const HolidayDialog = ({ dlgHoliday, handleHolidayYes }) => {

    return (
        <>
            <Dialog
                open={dlgHoliday}
                PaperProps={{
                    sx: {
                        border: '2px solid #ef4444', 
                        borderRadius: 2,             
                        boxShadow: 6,                
                    }
                }}
            >
                <DialogTitle></DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'red'
                    }}
                >
                    <ErrorOutlineIcon color="error" />
                    <Typography variant="body1" >
                     The Traveller/Participant is unavailable on the day.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleHolidayYes}>OK</Button>
                </DialogActions>
            </Dialog>

        </>
    );
};

export default HolidayDialog;